import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AddEmployeeDialog } from "@/components/AddEmployeeDialog";
import { api, formatApiError } from "@/lib/api";

export const TeamPanel = () => {
  const [staff, setStaff] = useState(null);

  useEffect(() => {
    api.get("/users").then((r) => setStaff(r.data)).catch((e) => {
      toast.error(formatApiError(e));
      setStaff([]);
    });
  }, []);

  return (
    <div className="space-y-6" data-testid="team-panel">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <p className="text-sm text-slate-400 max-w-lg">Staff sign in with email and password. Customers sign in with Google from the public page.</p>
        <AddEmployeeDialog onAdded={(s) => setStaff((list) => [...(list || []), s])} />
      </div>
      <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="team-list">
        {(staff || []).map((s) => (
          <li key={s.id} data-testid={`team-member-${s.id}`} className="border border-slate-800 bg-[#0A0F1C]/90 p-4">
            <div className="flex items-center justify-between gap-2">
              <p className="font-display text-sm uppercase tracking-wider truncate">{s.name}</p>
              <span className={`font-mono text-[10px] uppercase tracking-widest px-2 py-0.5 border ${s.role === "admin" ? "border-[#FF007F]/50 text-[#FF007F]" : "border-cyan-500/50 text-cyan-300"}`}>{s.role}</span>
            </div>
            <p className="font-mono text-xs text-slate-500 mt-1 truncate">{s.email}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};
